module.exports = __webpack_public_path__ + "static/media/welcome-bonus-web.81b26835.png";